import { Alert, Tooltip } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

type TextVariablesProps = {
  variables: string[];
  onVariableClick: (variable: string) => void;
};

const variableDescription: Record<string, string> = {
  code: "Coupon's secret code",
  name: "Coupon's name",
  description: "Coupon's description",
};

export const TextVariables: FC<TextVariablesProps> = ({ variables, onVariableClick }) => {
  const { t } = useTranslation();

  return (
    <TextVariablesInfoContainer severity="info" variant="filled">
      {t('variables')}
      <br />
      {variables.map((variable) => (
        <Tooltip title={variableDescription[variable] || ''}>
          <Variable
            onClick={() => {
              onVariableClick(` %${variable}%`);
            }}
          >
            {variable}
          </Variable>
        </Tooltip>
      ))}
    </TextVariablesInfoContainer>
  );
};

const TextVariablesInfoContainer = styled(Alert)`
  padding: 4px 8px;
  margin-top: 4px;
  margin-bottom: 24px;
  max-width: 290px;
  font-size: 12px;
  font-weight: 400;

  .MuiAlert-icon {
    display: none;
  }

  .MuiAlert-message {
    padding: 0;
  }
`;

const Variable = styled.div`
  display: inline-block;
  padding: 0 4px;
  color: #fff;
  font-weight: 500;
  background-color: #3899ec;
  margin-right: 4px;
  border-radius: 4px;
  cursor: pointer;

  :last-child {
    margin-right: 0;
  }
`;
